import isEqual from 'lodash-es/isEqual'
import omit from 'lodash-es/omit'
import uniqBy from 'lodash-es/uniqBy'

import { EMPTY_LIST, ENTITY_KEY_ID } from '../../../../../constants/common'
import { STATUS_FILTER_NAME } from '../../../../../constants/filter'
import { isRequestBoardItemRequestLatest } from '../../RequestBoard.utils'

function toRequestBoardExtraListing(filterValues) {
  return omit(filterValues, [STATUS_FILTER_NAME])
}

export function getRequestBoardLatestExtraItems({
  items,
  requestId,
  requestIds,
}) {
  return items.filter(item =>
    isRequestBoardItemRequestLatest({ id: item.id, requestId, requestIds })
  )
}

export function getRequestBoardExtraItems({ extra, filterValues }) {
  return isEqual(
    toRequestBoardExtraListing(extra.filterValues),
    toRequestBoardExtraListing(filterValues)
  )
    ? extra.items
    : EMPTY_LIST
}

export function mergeRequestBoardExtra({ filterValues, nextItems, prevExtra }) {
  return {
    filterValues,
    items: uniqBy(
      [
        ...nextItems,
        ...getRequestBoardExtraItems({ extra: prevExtra, filterValues }),
      ],
      ENTITY_KEY_ID
    ),
  }
}
